import { CardColorType } from '../card-color/card-color.type';
import { CardType } from '../card/card.type';

export type CardDisplayType = 'doppeldeutsch' | 'französisch' | 'alpinetricks';

export namespace CardDisplayType {
  export var configuredCardDisplayType: CardDisplayType = 'doppeldeutsch';

  export function getCardSrc(card: CardType): string {
    if (configuredCardDisplayType === 'doppeldeutsch')
      return `/assets/images/cards_new/doppeldeutsch/klassisch/cards/${card}.webp`;
    if (configuredCardDisplayType === 'französisch')
      return `/assets/images/cards/franzoesisch/${card}.svg`;
    if (configuredCardDisplayType === 'alpinetricks')
      return `/assets/images/cards/alpinetricks/${card}.png`;
  }

  export function getCardColorIconSrc(color: CardColorType, cardDisplayType?: CardDisplayType): string {
    const displayType = cardDisplayType || configuredCardDisplayType;
    
    if (displayType === 'doppeldeutsch') {
      return `/assets/images/cards_new/doppeldeutsch/klassisch/symbols/${color}.webp`;
    }
    if (displayType === 'französisch') {
      if (color === 'H') return `/assets/images/card-colors/herz.svg`;
      if (color === 'P') return `/assets/images/card-colors/pik.svg`;
      if (color === 'K') return `/assets/images/card-colors/karo.svg`;
      if (color === 'E') return `/assets/images/card-colors/kreuz.svg`;
    }
    if (displayType === 'alpinetricks') {
      if (color === 'H') return `/assets/images/card-colors/red.png`;
      if (color === 'P') return `/assets/images/card-colors/green.png`;
      if (color === 'K') return `/assets/images/card-colors/blue.png`;
      if (color === 'E') return `/assets/images/card-colors/yellow.png`;
    }
  }
}
